import { Component, Input, OnDestroy } from '@angular/core';
import { OtherSeoContent } from '~shared/models/other-seo-content.model';
import { CountryCode, FeatureToggleEnum, NEWSLETTER_PAGE_SOURCE, NUMBER_10, NUMBER_5 } from '~shared/constants';
import * as fromSeo from '../../store';
import { UserInfoState, isSubsidiary } from '~shared/modules/user-info/store';
import { Observable, Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Component({
  selector: 'app-other-content',
  templateUrl: './other-content.component.html',
  styleUrls: ['./other-content.component.scss'],
})
export class OtherContentComponent implements OnDestroy {
  private readonly NEWSLETTER_IDENTIFIER = 'newsletter-subscription';
  private _otherContent: Array<OtherSeoContent>;

  @Input() isSeoContentActive = false;
  @Input() source: NEWSLETTER_PAGE_SOURCE;
  @Input() isTableOfContentVisible = false;
  @Input()
  set otherContent(value: Array<OtherSeoContent>) {
    this._otherContent = this.editOtherContent(value);
  }

  get otherContent(): Array<OtherSeoContent> {
    return this._otherContent;
  }

  market: string;
  isSubsidiaryAccount$: Observable<boolean>;
  NLDiscount: string = NUMBER_10.toString();
  private unsubscribe$ = new Subject();

  constructor(
    private store: Store<fromSeo.SeoState | UserInfoState>,
    private featureFlagService: ActiveFeaturesConfigcatService
  ) {
    this.market = getCountryDomainCode();
    this.isSubsidiaryAccount$ = this.store.pipe(select(isSubsidiary));
    this.getNetherlandsDiscount();
  }

  isCategoryPlp(): boolean {
    return this.source === 'category-plp';
  }

  hasSmallSize(): boolean {
    return this.source !== NEWSLETTER_PAGE_SOURCE.LANDING_PAGE && this.isTableOfContentVisible;
  }

  private editOtherContent(value: Array<OtherSeoContent>): Array<OtherSeoContent> {
    if (!JSON.stringify(value).includes(this.NEWSLETTER_IDENTIFIER)) {
      const currentOtherContentLength = value.length;
      const newsletterBlock: OtherSeoContent = {
        type: this.NEWSLETTER_IDENTIFIER,
        value: [],
        order: currentOtherContentLength + 1,
      };

      return [...value, ...[newsletterBlock]];
    }

    return value;
  }

  getNetherlandsDiscount(): void {
    this.featureFlagService
      .isFeatureEnabledAndReady(FeatureToggleEnum.FF_NL_DISCOUNT_5)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((enabled) => {
        if (enabled && this.market === CountryCode.Netherlands) {
          this.NLDiscount = NUMBER_5.toString();
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
